// PHCDashboardAction.js

import { PHCDashboardConstants } from "./PHCDashboardConstants";

export const PHCDashboardAction = {};

PHCDashboardAction.fetchPortfolioRequest = () => ({
  type: PHCDashboardConstants.FETCH_PORTFOLIO_REQUEST,
});

PHCDashboardAction.fetchPortfolioSuccess = (payload) => {
  return {
    type: PHCDashboardConstants.FETCH_PORTFOLIO_SUCCESS,
    payload,
  };
};

PHCDashboardAction.fetchPortfolioFailure = (error) => ({
  type: PHCDashboardConstants.FETCH_PORTFOLIO_FAILURE,
  payload: error,
});

PHCDashboardAction.addPortfolio = (payload) => ({
  type: PHCDashboardConstants.ADD_PORTFOLIO,
  payload, // { portfolioId, portfolioName }
});

PHCDashboardAction.setCompletedPortfolio = (portfolioId) => ({
  type: PHCDashboardConstants.SET_COMPLETED_PORTFOLIO,
  payload: portfolioId,
});

PHCDashboardAction.updatePortfolio = (payload) => {
  return {
    type: PHCDashboardConstants.UPDATE_PORTFOLIO,
    payload,
  };
};

PHCDashboardAction.setTags = (tags) => ({
  type: PHCDashboardConstants.SET_TAGS,
  payload: tags,
});

PHCDashboardAction.setActivePortfolio = (id) => ({
  type: PHCDashboardConstants.SET_ACTIVE_PORTFOLIO,
  payload: id,
});

PHCDashboardAction.setCurrentView = (view) => ({
  type: PHCDashboardConstants.SET_CURRENT_VIEW,
  payload: view,
});

PHCDashboardAction.setJustUploadedPortfolio = (id) => ({
  type: PHCDashboardConstants.SET_JUST_UPLOADED_PORTFOLIO,
  payload: id,
});

PHCDashboardAction.addNonExistentPortfolio = (id) => ({
  type: PHCDashboardConstants.ADD_NON_EXISTENT_PORTFOLIO,
  payload: id,
});

PHCDashboardAction.setFromOneMoney = (value) => ({
  type: PHCDashboardConstants.SET_FROM_ONE_MONEY,
  payload: value,
});
